// extracted by mini-css-extract-plugin
module.exports = {"categories":"BillPaymentCategories_categories__3dYeD"};